




















































import {
  CourseTypeOption,
  ModuleResponseDTO
} from '@/jbi-shared/dto/jtms.dtos';
import { RootState } from '@/store/store';
import { Vue, Component, Prop, PropSync, Watch } from 'vue-property-decorator';
import { State } from 'vuex-class';

@Component({})
export default class ModuleForm extends Vue {
  @Prop({ type: Object }) module!: ModuleResponseDTO;
  @PropSync('name', { type: String }) syncedName!: string;
  @PropSync('courseType', { type: Object }) syncedCourseType!: CourseTypeOption;

  nameFieldMessage: string = '';
  nameHasError: boolean = true;

  @State((state: RootState) => state.course.courseTypes)
  courseTypes!: CourseTypeOption[];

  get getCourseTypeOptions() {
    if (this.courseTypes) {
      return this.courseTypes;
    }
    return [];
  }

  @Watch('syncedName')
  validateNameField(): void {
    if (!this.syncedName) {
      this.nameFieldMessage = 'Name field cannot be empty.';
      this.nameHasError = true;
      return;
    }

    this.nameHasError = false;
    this.nameFieldMessage = '';
  }

  updateErrorState() {
    const hasFieldError = this.nameHasError;
    this.$emit('update-error', hasFieldError);
  }

  @Watch('hasValuesChanged', { immediate: true })
  @Watch('nameHasError', { immediate: true })
  checkErrorMessageCallback(): void {
    this.updateErrorState();
  }
}
